// ArticlePreview.js
import React from 'react';
import { Link } from 'react-router-dom';
import '../css/ArticlePreview.css'; // Ensure this path matches your project structure

const ArticlePreview = ({ article }) => {
  const excerptSource = article.text || article.details || '';
  const excerpt = excerptSource.length > 180 ? `${excerptSource.slice(0, 177)}...` : excerptSource;
  const companyInitial = (article.companyName || 'I').charAt(0).toUpperCase();

  return (
    <Link to={`/articles/${article.id}`} className="article-preview-link">
      <article className="article-preview">
        <div className="preview-company-mark">{companyInitial}</div>
        <div className="preview-body">
          <div className="preview-meta-row">
            <span className="preview-company">{article.companyName}</span>
            <span className="preview-badge">{article.role}</span>
            <span className="preview-badge muted">{article.location}</span>
            <span className="preview-badge muted">{article.year}</span>
          </div>
          <h3 className="preview-title">{article.title}</h3>
          <p className="preview-excerpt">{excerpt || 'Open this interview to read the full breakdown.'}</p>
        </div>
        <div className="preview-arrow">Read</div>
      </article>
    </Link>
  );
};

export default ArticlePreview;
